import React from 'react';


function App() {

  const fname = 'Moobeen';
  const lname = 'Quader';
  const currdate = new Date().toLocaleDateString();
  const currtime = new Date().toLocaleTimeString();

  //-------------------

  let curDate = new Date();
  curDate = curDate.getHours();
  let greeting = "";
  const cssStyle = {};

  if (curDate >= 1 && curDate < 12) {
    greeting = "Good Morning";
    cssStyle.color = "green";
  } else if (curDate >= 12 && curDate < 19) {
    greeting = "Good Afternoon";
    cssStyle.color = "red";
  } else {
    greeting = "Good Night";
    cssStyle.color = "black";
  }

  return (
    <>
      <div>
        <h1 className='heading'>My name is {fname}  {lname}</h1>
        <p>test practice {5 + 5}</p>
        <p>Current Date is {currdate}</p>
        <p>Current Time is {currtime}</p>
        <hr></hr>

        <h2>Hello, Sir <span style={cssStyle}>{greeting}</span> </h2>
        <hr />
      </div>
    </>
  )

}
export default App;